import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=6ac6dfea&scoped=true"
import script from "./todoList.vue?vue&type=script&lang=js"
export * from "./todoList.vue?vue&type=script&lang=js"
import style0 from "./todoList.vue?vue&type=style&index=0&id=6ac6dfea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac6dfea",
  null
  
)

export default component.exports